import axios, { type AxiosInstance } from 'axios';

import type { OAuth2Credentials } from './types';

export class LoginClient<TCredential, TAuthResult> {
  private client: AxiosInstance;

  constructor(
    private baseUrl: string,
    private credentials: TCredential,
  ) {
    this.client = axios.create({
      baseURL: baseUrl,
    });
  }

  protected login = async (loginURL: string): Promise<TAuthResult> => {
    const config = {
      headers: {
        contentType: 'application/x-www-form-urlencoded',
      },
    };

    const oauth2 = this.credentials as unknown as OAuth2Credentials;

    const stringifiedCredentials = new URLSearchParams({
      client_id: oauth2.client_id,
      client_secret: oauth2.client_secret,
      scope: oauth2.scope,
      grant_type: oauth2.grant_type,
    });

    try {
      const result = await this.client.post<TAuthResult>(
        loginURL,
        stringifiedCredentials,
        config,
      );

      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}
